<template>
<div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="">
            <el-input v-model="dataForm.userName" placeholder="反馈人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-input v-model="dataForm.courseName" placeholder="课程名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-date-picker v-model="datetime" type="daterange" value-format="yyyy-MM-dd" :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button @click="rgetDataList()">查询</el-button>
        </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%">
        <el-table-column type="index" header-align="center" align="center" label="序号" :index="indexMethod" width="50">
        </el-table-column>
        <el-table-column prop="courseName" header-align="center" align="center" label="课程名称">
        </el-table-column>
        <el-table-column prop="userName" header-align="center" align="center" label="反馈人">
        </el-table-column>
        <el-table-column prop="orgName" header-align="center" align="center" label="所属机构">
        </el-table-column>

        <el-table-column prop="content" header-align="center" align="center" label="反馈内容" show-overflow-tooltip>
            <template #default="{ row }">
                <a style="cursor: pointer" @click="onClickContent(row)">
                    {{ getContent(row.content) || "预览" }}
                </a>
            </template>
        </el-table-column>
        <el-table-column prop="files" header-align="center" align="center" label="反馈附件">
            <template #default="{ row }">
                <el-tag size="size" v-for="v in getTags(row.files)" :key="v.index" style="margin: 0 5px 5px 0; cursor: pointer" @click="onClickTag(v.url)">{{ v.name }}
                </el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="createTime" header-align="center" align="center" label="反馈时间">
        </el-table-column>

        <el-table-column prop="toUserName" header-align="center" align="center" label="回复人">
        </el-table-column>
        <el-table-column prop="toCommentContent" header-align="center" align="center" label="回复内容">
        </el-table-column>
        <el-table-column prop="updateTime" header-align="center" align="center" label="更新时间">
        </el-table-column>
        <el-table-column header-align="center" align="center" width="150" label="操作">
            <template slot-scope="scope">
                <el-button type="text" v-if=" isAuth('course:comment:answer')" size="small" @click="addOrUpdateHandle(scope.row.id)">反馈回复</el-button>
                <el-button type="text" v-if=" isAuth('course:comment:delete')" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <el-dialog title="预览内容" :visible.sync="contentFlag" width="70%" @close="onCloseContent">
        <div v-html="content"></div>
        <span slot="footer">
            <el-button type="primary" @click="onCloseContent">确定</el-button>
        </span>
    </el-dialog>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
</div>
</template>

<script>
import AddOrUpdate from './comment-add-or-update'
export default {
    data() {
        return {
            dataForm: {
                courseName: "",
                userName: "",
                startTime: "",
                endTime: "",
            },
            datetime: "",
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            contentFlag: false,
            addOrUpdateVisible: false,
            content: "",
        };
    },
    watch: {
        datetime(val) {
            if (val) {
                this.dataForm.startTime = val[0];
                this.dataForm.endTime = val[1];
            } else {
                this.dataForm.startTime = "";
                this.dataForm.endTime = "";
            }
        },
    },
    components: {
        AddOrUpdate
    },
    created() {
        this.getDataList();
        this.doSearch();
    },
    methods: {
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        getTags(v) {
            if (v) {
                let arr = v.split(";");
                arr = arr.map((j) => {
                    let b = j.split("/");
                    return {
                        name: decodeURI(b[b.length - 1]),
                        url: j
                    };
                });
                return arr;
            } else {
                return [];
            }
        },
        doSearch() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.rgetDataList();
                }
            }
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("course/comment/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    ...this.dataForm,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                  console.log(data)
                    this.dataList = data.page.list;
                    this.totalPage = data.page.totalCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                    this.$message.error(data.msg);
                }
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定删除该条反馈?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http({
                    url: this.$http.adornUrl("course/comment/delete"),
                    method: "delete",
                    data: id,
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.getDataList();
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            });
        },
        getContent(content) {
            return content
                .replace(/<[^>]+>/g, "")
                .replace(/&nbsp;/g, "")
                .replace(/undefined/g, "");
        },
        onCloseContent() {
            this.contentFlag = false;
            this.content = "";
        },
        onClickContent(row) {
            if (!row.content) {
                return this.$message.error("暂无可预览功能");
            }
            this.content = row.content;
            this.contentFlag = true;
        },
        onClickTag(v) {
            window.open(v, "_blank");
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id)
            })
        },
    },
};
</script>
